export default {
  stepTitle: {
    id: 'mobile_plan_step_title',
    defaultMessage: 'Select a 5G mobile plan',
  },
  cardGuidanceBackMarketTitle: {
    id: 'mobile_plan_step_card_guidance_title',
    defaultMessage: 'Get Back Market Mobile',
  },
  cardGuidanceBackMarketLabel: {
    id: 'mobile_plan_step_card_guidance_label',
    defaultMessage: 'Unlimited calls and texts on premium 5G data for less.',
  },
  pricePerMonth: {
    id: 'mobile_plan_step_price_per_month',
    defaultMessage: '+{pricePerMonth}/month',
  },
  noMobilePlan: {
    id: 'mobile_plan_step_no_mobile_plan',
    defaultMessage: 'No mobile plan',
  },
  unlimitedDataPlan: {
    id: 'mobile_plan_step_unlimited_data_plan',
    defaultMessage: 'Unlimited data plan',
  },
  option10GB: {
    id: 'mobile_plan_step_option_10_gb',
    defaultMessage: '10GB plan',
  },
  option50GB: {
    id: 'mobile_plan_step_option_50_gb',
    defaultMessage: '50GB plan',
  },
  cancelAnytime: {
    id: 'mobile_plan_step_cancel_anytime',
    defaultMessage: 'Cancel anytime',
  },
  backMarketDrawerTitle: {
    id: 'mobile_plan_drawer_back_market_title',
    defaultMessage: 'Back Market Mobile',
  },
}
